// **Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// **Utils Imports
import {
  getAppMode,
  getJWTToken,
  getUserDetails,
  removeJWTToken,
  setAppModeInStorage,
  setJWTToken
} from '../../../utils/utils'
import { APP_MODE, ROLES } from '../../../utils/constant'

const token = getJWTToken()
const userData = getUserDetails()
const appMode = getAppMode()

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token,
    appMode,
    userData,
    profile: {},
    isAuthenticated: !!userData,
    currentlyActivePlan: null,
    subscriptions: []
  },
  reducers: {
    setAppMode(state, action) {
      setAppModeInStorage(action.payload)
      state.appMode = action.payload
    },
    setCurrentlyActivePlan(state, action) {
      state.currentlyActivePlan = action.payload
    },
    setSubscriptions(state, action) {
      state.subscriptions = action.payload
    },
    setToken(state, action) {
      state.token = action.payload
      state.isAuthenticated = true
    },
    logout(state) {
      removeJWTToken()
      state.token = null
      state.userData = null
      state.isAuthenticated = false
      state.currentlyActivePlan = null
    },
    setUserInformation(state, action) {
      try {
        const jwt = action.payload.jwt
        setJWTToken(jwt)

        const userData = getUserDetails()

        if (userData?.roles?.toLowerCase() === ROLES.LEARNER) {
          setAppModeInStorage(APP_MODE.LEARNER)
          state.appMode = APP_MODE.LEARNER
        } else {
          setAppModeInStorage(APP_MODE.HIRING)
          state.appMode = APP_MODE.HIRING
        }

        if (userData) {
          state.token = jwt
          state.userData = userData
          state.isAuthenticated = true
        }
      } catch (e) {}
    },
    setProfileDetails(state, action) {
      const { name = '' } = action.payload || {}
      if (name) {
        state.userData.name = name
      }
      state.profile = action.payload
    }
  }
})

export const {
  logout,
  setToken,
  setAppMode,
  setUserInformation,
  setCurrentlyActivePlan,
  setSubscriptions,
  setProfileDetails
} = authSlice.actions

export default authSlice.reducer
